module.exports = __webpack_public_path__ + "img/20_rain.fdc0451f.jpg";